export default __webpack_public_path__ + "static/media/concord169.017c3dbf.png";